// extracted by mini-css-extract-plugin
export default {"modal-overlay":"circularModalLoader_modal-overlay__tzg6o"};